export default __webpack_public_path__ + "static/media/card.bf653acd.png";